import MembersBlockView from './components/theme/Blocks/MembersBlock/View';
import MembersBlockEdit from './components/theme/Blocks/MembersBlock/Edit';
import 'semantic-ui-css/components/icon.min.css';
import { membersblockSVG } from './helpers/icons';
import { composeSchema } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';

const applyConfig = (config) => {
  config.settings.isMultilingual = false;
  config.settings.supportedLanguages = ['en'];
  config.settings.defaultLanguage = 'en';
  config.settings.enableQuanta = true;

  config.settings.enableBlockChooser = true;

  /**
   * CUSTOM START
   */

  // Remove slate from integratesBlockStyles to ensure wrapper div is always rendered
  config.settings.integratesBlockStyles = (config.settings.integratesBlockStyles || []).filter(
    type => type !== 'slate'
  );

    // font color
  const defaultheme = config.blocks.themes.find(t => t.name === 'default');

  defaultheme.style['--theme-foreground-color'] = '#232577';

  // slate text background color
  const addThemesTo = (key) => {
    const blk = config.blocks.blocksConfig?.[key];
    if (!blk) return;
    const existing = blk.themes || [];

    const extra = [
      {
        name: 'esgld-blue',
        label: 'ESGLD Blue',
        style: {
          '--theme-color': '#232577',
          '--theme-high-contrast-color': '#232577',
          '--theme-foreground-color': '#FFFFFF',
          '--theme-low-contrast-foreground-color': '#F1F5F9',
        },
      },
      {
        name: 'esgld-indigo',
        label: 'ESGLD Indigo',
        style: {
          '--theme-color': '#7c6fcd',
          '--theme-high-contrast-color': '#7c6fcd',
          '--theme-foreground-color': '#FFFFFF',
          '--theme-low-contrast-foreground-color': '#F8FAFC',
        },
      },
    ];

    const names = new Set(existing.map((t) => t.name));
    blk.themes = [...existing, ...extra.filter((t) => !names.has(t.name))];
  };

  addThemesTo('slate');

  // Text alignment: block width

    // Text alignment
  const BLOCK_WIDTH_SCHEMA = {
    widget: 'align',
    actions: ['narrow', 'normal', 'wide', 'full'],
    defaultAction: 'narrow',
  };

  const BLOCK_WIDTH_DEFAULT_SCHEMA = {
    blockWidth: 'narrow',
  };

  const addNewStyleSchema = (
    schema,
    newField,
    newFieldSchema,
    defaultStyles,
  ) => {
    if (!schema.properties.styles) {
      schema.fieldsets.push({
        id: 'styling',
        title: 'Styling',
        fields: ['styles'],
      });
      schema.properties = {
        ...schema.properties,
        styles: {
          schema: {
            fieldsets: [
              {
                id: 'default',
                title: 'default',
                fields: [],
              },
            ],
            properties: {},
          },
          widget: 'object',
          title: 'styling',
        },
      };
    }
    schema.properties.styles.schema.fieldsets[0].fields = [
      newField,
      ...schema.properties.styles.schema.fieldsets[0].fields,
    ];

    schema.properties.styles.schema.properties[newField] = {
      ...newFieldSchema,
      title: newField,
    };

    if (defaultStyles) {
      schema.properties.styles.default = {
        ...defaultStyles,
      };
    }

    return schema;
  };

  if (config.blocks.blocksConfig.slate) {
    const oldEnhancer = config.blocks.blocksConfig.slate.schemaEnhancer;
    config.blocks.blocksConfig.slate.schemaEnhancer = composeSchema(
      oldEnhancer,
      ({ schema }) =>
        addNewStyleSchema(
          schema,
          'blockWidth',
          BLOCK_WIDTH_SCHEMA,
          BLOCK_WIDTH_DEFAULT_SCHEMA,
        ),
    );
  }

  if (config.blocks.blocksConfig.heading) {
    const oldEnhancer = config.blocks.blocksConfig.heading.schemaEnhancer;
    config.blocks.blocksConfig.heading.schemaEnhancer = composeSchema(
      oldEnhancer,
      ({ schema }) =>
        addNewStyleSchema(
          schema,
          'blockWidth',
          BLOCK_WIDTH_SCHEMA,
          BLOCK_WIDTH_DEFAULT_SCHEMA,
        ),
    );
  }

  if (config.blocks.blocksConfig.accordion) {
    const oldEnhancer = config.blocks.blocksConfig.accordion.schemaEnhancer;
    config.blocks.blocksConfig.accordion.schemaEnhancer = composeSchema(
      oldEnhancer,
      ({ schema }) =>
        addNewStyleSchema(
          schema,
          'blockWidth',
          BLOCK_WIDTH_SCHEMA,
          BLOCK_WIDTH_DEFAULT_SCHEMA,
        ),
    );
  }

  if (config.blocks.blocksConfig.__button) {
    const oldEnhancer = config.blocks.blocksConfig.__button.schemaEnhancer;
    config.blocks.blocksConfig.__button.schemaEnhancer = composeSchema(
      oldEnhancer,
      ({ schema }) =>
        addNewStyleSchema(
          schema,
          'blockWidth',
          BLOCK_WIDTH_SCHEMA,
          BLOCK_WIDTH_DEFAULT_SCHEMA,
        ),
    );
  }

  // Members Block
  config.blocks.blocksConfig.membersblock = {
    id: 'membersblock',
    title: 'Members Block',
    icon: membersblockSVG,
    group: 'common',
    view: MembersBlockView,
    edit: MembersBlockEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    schemaEnhancer: ({ schema }) => schema,
  };


  // Listing-Block
  const listingCfg = config.blocks.blocksConfig.listing;
  if (listingCfg) {
    const prevEnhancer = listingCfg.schemaEnhancer;

    listingCfg.schemaEnhancer = (args) => {
      const { schema, formData, intl } = args;
      const baseSchema = prevEnhancer ? prevEnhancer(args) : schema;

      baseSchema.properties.customButtonText = {
        title: 'Custom Button Text',
        type: 'string',
        widget: 'text',
        default: 'Read more',
        description: 'Text für den Button unterhalb der Beschreibung',
      };

      if (baseSchema.fieldsets && baseSchema.fieldsets[0]) {
        const fs = baseSchema.fieldsets[0];
        if (!fs.fields.includes('customButtonText')) {
          fs.fields.push('customButtonText');
        }
      }

      return baseSchema;
    };
  }

  // Slider-Block erweitern
  const sliderCfg = config.blocks.blocksConfig.slider;
  if (sliderCfg) {
    const prevSliderEnhancer = sliderCfg.schemaEnhancer;

    sliderCfg.schemaEnhancer = (args) => {
      const { schema, formData, intl } = args;
      const baseSchema = prevSliderEnhancer ? prevSliderEnhancer(args) : schema;

      if (baseSchema.properties?.slides?.schema) {
        const slidesSchema = baseSchema.properties.slides.schema;

        if (!slidesSchema.properties.buttonText) {
          slidesSchema.properties.buttonText = {
            title: 'Button text',
            type: 'string',
          };
        }
        if (
          slidesSchema.fieldsets?.[0]?.fields &&
          !slidesSchema.fieldsets[0].fields.includes('buttonText')
        ) {
          slidesSchema.fieldsets[0].fields.push('buttonText');
        }

        if (!slidesSchema.properties.hideButton) {
          slidesSchema.properties.hideButton = {
            title: 'Hide Button',
            type: 'boolean',
          };
        }
        if (
          slidesSchema.fieldsets?.[0]?.fields &&
          !slidesSchema.fieldsets[0].fields.includes('hideButton')
        ) {
          slidesSchema.fieldsets[0].fields.push('hideButton');
        }
      }

      return baseSchema;
    };
  }

  /**
   * CUSTOM END
   */


  return config;
};

export default applyConfig;